import type {WorkspaceTransferUiConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceConfig";

export const TRANSFER_REASON_OTHER_ID = "other";

const DEFAULT_BULK_SELECT_MAX_TAG_COUNT = 2;

/** Fallback transfer UI constants when workspace config omits `transfer`. */
export const DEFAULT_TRANSFER_UI_CONFIG: WorkspaceTransferUiConfig = {
    listPageLabel: "Leads",
    showDimensionSelector: true,
    bulkSelectMaxTagCount: DEFAULT_BULK_SELECT_MAX_TAG_COUNT,
    reasons: [
        {id: "user-suspension", label: "User Suspension"},
        {id: "user-on-leave", label: "User on Leave"},
        {id: "incorrect-owner-assignment", label: "Incorrect owner assignment"},
        {id: "workload-balancing", label: "Workload balancing"},
        {id: "customer-requested-another-executive", label: "Customer requested another executive"},
        {id: "performance-based-redistribution", label: "Performance-based redistribution"},
        {id: "bulk-movement-between-executives", label: "Bulk movement between executives"},
        {id: TRANSFER_REASON_OTHER_ID, label: "Other"},
    ],
    remarksRequiredWhenReasonId: TRANSFER_REASON_OTHER_ID,
    previewColumns: [
        {id: "currentOwner", label: "Current Owner", kind: "currentOwner"},
        {id: "transferredOwner", label: "Transferred Owner", kind: "transferredOwner"},
        {id: "transferredOn", label: "Transferred on", kind: "transferredOn"},
        {id: "currentOu", label: "Current OU", kind: "currentOu"},
        {id: "transferredOu", label: "Transferred OU", kind: "transferredOu"},
        {id: "transferReason", label: "Transfer reason", kind: "transferReason"},
    ],
    bulkPreviewColumns: [
        {id: "customerName", label: "Customer Name", kind: "customerName"},
        {id: "contactNumber", label: "Contact number", kind: "contactNumber"},
        {id: "status", label: "Status", kind: "status"},
        {id: "currentOwner", label: "Current Owner", kind: "currentOwner"},
        {id: "transferredOwner", label: "Transferred Owner", kind: "transferredOwner"},
        {id: "transferredOn", label: "Transferred on", kind: "transferredOn"},
        {id: "currentOu", label: "Current OU", kind: "currentOu"},
    ],
};

export function resolveTransferUiConfig(
    transferUi: Partial<WorkspaceTransferUiConfig> | undefined,
): WorkspaceTransferUiConfig {
    if (transferUi === undefined) {
        return DEFAULT_TRANSFER_UI_CONFIG;
    }
    return {
        ...DEFAULT_TRANSFER_UI_CONFIG,
        ...transferUi,
        bulkPreviewColumns: transferUi.bulkPreviewColumns ?? DEFAULT_TRANSFER_UI_CONFIG.bulkPreviewColumns,
        bulkSelectMaxTagCount: transferUi.bulkSelectMaxTagCount ?? DEFAULT_TRANSFER_UI_CONFIG.bulkSelectMaxTagCount,
        previewColumns:
            transferUi.previewColumns !== undefined && transferUi.previewColumns.length > 0
                ? transferUi.previewColumns
                : DEFAULT_TRANSFER_UI_CONFIG.previewColumns,
        reasons:
            transferUi.reasons !== undefined && transferUi.reasons.length > 0
                ? transferUi.reasons
                : DEFAULT_TRANSFER_UI_CONFIG.reasons,
    };
}
